import { createClient } from '@supabase/supabase-js';

let supabaseUrl;
let supabaseKey;

if (process.env.REACT_APP_ENV === 'development') {
  supabaseUrl = process.env.REACT_APP_SUPABASE_URL_LOCAL;
  supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY_LOCAL;
  // console.log('Development mode:', {
  //   reactAppEnv: process.env.REACT_APP_ENV,
  //   supabaseUrl,
  //   hasKey: !!supabaseKey
  // });
} else {
  supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
}

// Debug: Log final values before client creation

const customFetch = async (url, options) => fetch(url, options);

const supabaseOptions = {
  fetch: customFetch,
};

// Create the supabase client with custom options
export const supabase = createClient(supabaseUrl, supabaseKey, supabaseOptions);
